import { Navigate } from "react-router";
import { useRepresentativePermissions } from "@/shared/hooks/useRepresentativePermissions";
import { useParametersNavigation } from "../hooks/useParametersNavigation";

const ParametersIndexRedirect = () => {
  const { permissions } = useRepresentativePermissions();
  const { tabs } = useParametersNavigation();

  if (permissions === null) return null;
  if (tabs.length === 0) return null;

  return <Navigate to={tabs[0].path} replace />;
};

export default ParametersIndexRedirect;
